import SectionTitle from "../components/SectionTitle";
import PageSeo from "../components/PageSeo";
import Reveal from "../components/Reveal";
import DonationWidget from "../components/DonationWidget";
import { ASSETS } from "../mock";
import { Heart, Users, Award, Sparkles } from "lucide-react";

export default function Asociacion() {
  return (
    <div>
      <PageSeo
        title="La Asociación"
        description="Conoce la Asociación Pequeño Fresno, sus valores y cómo puedes unirte a nuestra causa para apoyar a las familias afectadas por el Complejo de Esclerosis Tuberosa."
        path="/asociacion"
      />
      <section className="max-w-6xl mx-auto px-6">
        <SectionTitle>~ la asociación ~</SectionTitle>

        {/* Official Logo */}
        <Reveal>
          <div className="flex justify-center mb-14">
            <div className="relative">
              <div className="absolute inset-0 rounded-full pf-gradient blur-3xl opacity-40 scale-90" aria-hidden="true" />
              <img
                src={ASSETS.logo}
                alt="Logo oficial Asociación Pequeño Fresno · Esclerosis Tuberosa"
                className="relative w-64 sm:w-80 md:w-96 h-auto drop-shadow-lg"
              />
            </div>
          </div>
        </Reveal>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <div className="space-y-5 text-[color:var(--text)] prose-body">
              <p>Te invitamos a unirte a nuestra causa y a ser parte de esta gran familia que crece día a día. Juntos, podemos hacer la diferencia.</p>
              <p>La <strong>“Asociación Pequeño Fresno Esclerosis Tuberosa”</strong> de Alacant/Alicante, figura inscrita en la Sección PRIMERA del Registro Autonómico con el número <span className="font-mono text-[color:var(--brand)]">CV-01-066518-A</span>.</p>
              <p>Aunque estamos comenzando, en Pequeño Fresno nos sentimos inmensamente agradecidos por todas las personas y organizaciones que han confiado en nosotros. Cada proyecto, cada gesto y cada granito de arena nos motivan a seguir adelante y a soñar con un futuro donde podamos ayudar a más familias afectadas por el Complejo de Esclerosis Tuberosa.</p>
              <a href="https://donorbox.org/ayudanos-934402" target="_blank" rel="noreferrer" className="btn-accent inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold shadow-lg mt-2">
                <Heart className="w-5 h-5" /> Ayúdanos
              </a>
            </div>
          </Reveal>

          <Reveal delay={150}>
            <div className="relative">
              <div className="pf-soft rounded-3xl p-10 relative overflow-hidden">
                <img src={ASSETS.butterflyLeaf} alt="" className="absolute -right-8 -top-8 w-52 opacity-70" />
                <img src={ASSETS.leafDeco} alt="" className="absolute -left-8 -bottom-8 w-40 opacity-60" />
                <h3 className="h-serif text-3xl font-semibold text-[color:var(--brand-strong)] mb-4 relative">Nuestra misión</h3>
                <ul className="space-y-4 relative">
                  {[
                    { icon: Users, text: "Acompañar a familias que conviven con el CET." },
                    { icon: Award, text: "Sensibilizar sobre esta enfermedad rara." },
                    { icon: Sparkles, text: "Impulsar iniciativas solidarias que generen impacto." },
                    { icon: Heart, text: "Mejorar la calidad de vida de Lia." },
                  ].map((it, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <span className="mt-1 p-2 rounded-full bg-white shadow-sm">
                        <it.icon className="w-5 h-5 text-[color:var(--brand)]" />
                      </span>
                      <span className="text-[color:var(--text)]">{it.text}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Reveal>
        </div>

        {/* Donation Widget */}
        <Reveal>
          <div className="mt-16 pf-gradient rounded-3xl p-8 sm:p-12 relative overflow-hidden text-center">
            <img src={ASSETS.butterflyLeaf} alt="" className="absolute -left-8 -bottom-8 w-32 opacity-50 rotate-12" />
            <img src={ASSETS.smallLeaf} alt="" className="absolute -right-6 top-6 w-20 opacity-60 -rotate-12" />
            <h3 className="h-serif text-3xl sm:text-4xl font-semibold text-[color:var(--brand-strong)] relative">Únete a nuestra causa</h3>
            <p className="mt-3 max-w-xl mx-auto text-[color:var(--text)] relative">
              Con tu aportación seguimos volando y llegando a más familias.
            </p>
            <div className="mt-6 relative">
              <DonationWidget />
            </div>
          </div>
        </Reveal>

        <div className="mt-20 grid md:grid-cols-3 gap-6">
          {[
            { title: "Empatía", body: "Escuchamos y acompañamos a cada familia con respeto y cariño." },
            { title: "Solidaridad", body: "Creemos en la fuerza de los pequeños gestos y de la comunidad." },
            { title: "Transparencia", body: "Cada donación se destina íntegramente a nuestra causa." },
          ].map((v, i) => (
            <Reveal key={i} delay={i * 120}>
              <div className="pf-soft rounded-2xl p-6 hover-lift h-full">
                <h4 className="h-serif text-2xl font-semibold text-[color:var(--brand-strong)]">{v.title}</h4>
                <p className="prose-body mt-3 text-[color:var(--text)]">{v.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
